"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensLineageCountsQueryWrapper = void 0;
var components_1 = require("@apollo/client/react/components");
var react_1 = __importDefault(require("react"));
var queries_1 = require("../../../gen-src/queries");
var LineageCountsFunctions_1 = require("../lineage/LineageCountsFunctions");
function createUnfilteredCounts(data) {
    var lens = (data === null || data === void 0 ? void 0 : data.lenses) && data.lenses[0];
    if (lens
        && lens.upstreamDatabasesConnection
        && lens.upstreamTablesConnection
        && lens.upstreamVirtualConnectionsConnection
        && lens.upstreamVirtualConnectionTablesConnection
        && lens.upstreamFlowsConnection
        && lens.upstreamDatasourcesConnection
        && lens.fieldsConnection
        && lens.downstreamDashboardsConnection
        && lens.downstreamWorkbooksConnection
        && lens.downstreamMetricsConnection
        && lens.downstreamOwnersConnection) {
        return {
            upstreamDatabases: lens.upstreamDatabasesConnection.totalCount,
            upstreamTables: lens.upstreamTablesConnection.totalCount,
            upstreamVirtualConnections: lens.upstreamVirtualConnectionsConnection.totalCount,
            upstreamVirtualConnectionTables: lens.upstreamVirtualConnectionTablesConnection.totalCount,
            upstreamFlows: lens.upstreamFlowsConnection.totalCount,
            upstreamDatasources: lens.upstreamDatasourcesConnection.totalCount,
            fields: lens.fieldsConnection.totalCount,
            downstreamDashboards: lens.downstreamDashboardsConnection.totalCount,
            downstreamWorkbooks: lens.downstreamWorkbooksConnection.totalCount,
            downstreamMetrics: lens.downstreamMetricsConnection.totalCount,
            downstreamOwners: lens.downstreamOwnersConnection.totalCount,
        };
    }
    return null;
}
var LensLineageCountsQueryWrapper = function (props) {
    return react_1.default.createElement(components_1.Query, { query: queries_1.LensLineageCountsDocument, variables: { vizportalUrlId: props.vizportalUrlId } }, function (result) { return react_1.default.createElement(react_1.default.Fragment, null, (0, LineageCountsFunctions_1.renderUnfilteredLineageCounts)(result, createUnfilteredCounts, props.children)); });
};
exports.LensLineageCountsQueryWrapper = LensLineageCountsQueryWrapper;
//# sourceMappingURL=LensLineageCountsQueryWrapper.js.map